module.exports = __webpack_public_path__ + "img/122.38cc01c1.jpg";